import React from 'react'
import { connect } from 'react-redux'

class ForgotPasswordPage extends React.Component {
  componentWillMount() {

  }
  componentWillUnmount() {

  }
  render() {
    return (
      <main />
    )
  }
}

export default connect(() => ({}), {})(ForgotPasswordPage)



// WEBPACK FOOTER //
// ./src/browser/pages/ForgotPassword.js